/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Demo_TitleInputs */

const en_landing_demo_title = /** @type {(inputs: Landing_Demo_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`See Alchema in action`)
};

const de_landing_demo_title = /** @type {(inputs: Landing_Demo_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alchema in Aktion`)
};

const fr_landing_demo_title = /** @type {(inputs: Landing_Demo_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vois Alchema en action`)
};

const es_landing_demo_title = /** @type {(inputs: Landing_Demo_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mira Alchema en acción`)
};

const it_landing_demo_title = /** @type {(inputs: Landing_Demo_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vedi Alchema in azione`)
};

const nl_landing_demo_title = /** @type {(inputs: Landing_Demo_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zie Alchema in actie`)
};

const pl_landing_demo_title = /** @type {(inputs: Landing_Demo_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zobacz Alchema w akcji`)
};

const fi_landing_demo_title = /** @type {(inputs: Landing_Demo_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Näe Alchema toiminnassa`)
};

const da_landing_demo_title = /** @type {(inputs: Landing_Demo_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Se Alchema i aktion`)
};

const sv_landing_demo_title = /** @type {(inputs: Landing_Demo_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Se Alchema i praktiken`)
};

/**
* | output |
* | --- |
* | "See Alchema in action" |
*
* @param {Landing_Demo_TitleInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const landing_demo_title = /** @type {((inputs?: Landing_Demo_TitleInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Demo_TitleInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_landing_demo_title(inputs)
	if (locale === "fr") return fr_landing_demo_title(inputs)
	if (locale === "es") return es_landing_demo_title(inputs)
	if (locale === "it") return it_landing_demo_title(inputs)
	if (locale === "nl") return nl_landing_demo_title(inputs)
	if (locale === "pl") return pl_landing_demo_title(inputs)
	if (locale === "fi") return fi_landing_demo_title(inputs)
	if (locale === "da") return da_landing_demo_title(inputs)
	if (locale === "sv") return sv_landing_demo_title(inputs)
	return en_landing_demo_title(inputs)
});